import { Directive, HostListener } from '@angular/core';

@Directive({
  selector: '[appOnlyDigits]'
})

export class OnlyDigitsDirective {

  @HostListener('input', ['$event'])
  onKeydown(event: KeyboardEvent): void {
    const input = event.target as HTMLInputElement;

    if (/[.\D]/g.test(input.value)) {
      const newValue = input.value.replace(/[.\D]/g, '');
      input.value = newValue;
    }
  }
}
